import WithRender from "../../templates/base/pageOption.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getPageAttributesInPageOptions", "getActivePageOptions"]),

    name: function () {
      return this.propsData.label;
    }
  },

  methods: {
    ...mapActions(["setActiveProductPageOption"]),
    onClickSelectPageOption(option) {
      this.setActiveProductPageOption(option);
    },
    activeClass: function () {
      return this.getActivePageOptions == this.code ? "active" : "";
    }
  },
  props: ["propsData", "index", "code"]
});
